<!-- <app-menus></app-menus> -->
<app-header-v2></app-header-v2>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<app-error-toast [message]="error" *ngIf="error"></app-error-toast>
